import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ISector } from "../../utils/types/models";

export default createEntityReducer<ISector>(Endpoint.Sectors, Endpoint.SectorsList);
